// let's also include the CustomEvent here to make it work on IE11
(() => {
    if (typeof (window as any).CustomEvent === "function") {
        return false;
    }

    (window as any).CustomEvent = (event, params) => {
        params = params || { bubbles: false, cancelable: false, detail: null };
        const evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    };
})();

(() => {
    (window as any).registeredEventNames = new Set<EventNames>();
})();

/**
 * The idea of this file is to place all the events that we use
 * to communicate between the different modules in the app
 * given that we have taken the approach of multi page app
 */

export enum EventNames {
    GoHome = "go-home",
    LoginStatusUpdate = "login-status-updated",
    NotificationSent = "notification-sent",
    ShowLogin = "show-login",
    ShowSetExistingClientCredentials = "show-set-existing-client-credentials",
}

export const dispatchEvent = <T = any>(eventName: EventNames, data?: T) => {
    const evt = new CustomEvent<T>(eventName, { detail: data });
    document.dispatchEvent(evt);

    if (!isEventRegistered(eventName)) {
        console.warn(`Event ${eventName} is not registered.`);
    }
};

export const listenEvent = <T>(eventName: EventNames, callback: (data: T) => void) => {
    document.addEventListener(eventName, (data: CustomEvent<T>) => callback(data.detail));

    (window as any).registeredEventNames.add(eventName);
};

export const detachListener = (eventName: EventNames, listener: any) => {
    document.removeEventListener(eventName, listener);

    (window as any).registeredEventNames.delete(eventName);
};

export const isEventRegistered = (eventName: EventNames): boolean => {
    return (window as any).registeredEventNames.has(eventName);
};
